<template>
    <div class="link-collapse-group" :class="[`link-collapse-group-shape-${shape}`]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'link-collapse-group',
        props: {
            limit: {type: Number},
            shape: {type: String, default: 'none'},
        },
        data() {
            return {
                items: [],
                stack: [],
            };
        },
        methods: {
            lv_add(collapse) {
                this.items.push(collapse);
                if (!!collapse.currentValue) {
                    this.stack.push(collapse);
                }
            },
            lv_remove(collapse) {
                this.items.splice(this.items.indexOf(collapse), 1);
            },
            lv_click(val, collapse) {
                if (!val) {
                    this.stack.push(collapse);
                    if (!!this.limit && this.limit > 0 && this.stack.length > this.limit) {
                        this.stack.shift().currentValue = false;
                    }
                } else {
                    this.stack.splice(this.stack.indexOf(collapse), 1);
                }
            },
        },
    };
</script>

<style lang="scss">
   @include themeify{
       .link-collapse-group {
           display: block;
           vertical-align: middle;
           box-sizing: border-box;

           .link-collapse {
               border: none;
               &:not(:last-child) {
                   box-sizing: border-box;
               }
           }

       }

       /*shape*/
       @each $key, $value in $list-shape {
           &.link-collapse-group-shape-#{$key} {
               border-radius: $value;
               overflow: hidden;
           }
       }
   }
</style>
